import { createStore, applyMiddleware, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';
import RavenMiddleware from 'redux-raven-middleware';
import rootReducer from '../reducers';
import rootSaga from '../sagas';
import analyticsSaga from '../sagas/analytics';

const sagaMiddleware = createSagaMiddleware();

const finalCreateStore = compose(
    applyMiddleware(
        RavenMiddleware(`https://9a9580ddb55d4cbc935c998b7b3a5e10@sentry.io/105423`),
        sagaMiddleware
    ),
)(createStore);

export default function configureStore(initialState) {
    const store = finalCreateStore(rootReducer, initialState);

    sagaMiddleware.run(rootSaga);
    sagaMiddleware.run(analyticsSaga);

    return store;
}



// WEBPACK FOOTER //
// ./scripts/store/configureStore.prod.js